import React, { FC, useState } from "react";

// i18n
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

// types
import { IOutlets } from "@Libs/Transclusion/types/outlets";
import { PayWithBancontact as Stripe } from "./Adapters/Stripe/PayWithBancontact";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";

type Props = Omit<
  IOutlets["configure-payment.body"]["props"],
  "paymentMethod" | "basket"
> & { isAllowedPaymentMethodSingle?: boolean };

const PROVIDER_ADAPTERS = {
  stripe: Stripe,
};

export const PayWithBancontact: FC<Props> = (props) => {
  const [showError, setShowError] = useState<boolean>(false);

  const Adapter = PROVIDER_ADAPTERS["stripe"];

  const handleError = () => {
    setShowError(true);
  };

  const handleAlertClick = () => {
    setShowError(false);
    props.onBack();
  };

  return (
    <PaymentMethodForm>
      {showError && <PaymentMethodForm.Error onClick={handleAlertClick} />}
      <PaymentMethodForm.Header
        onChangeClick={props.onBack}
        paymentMethod={PaymentMethodType.BANCONTACT}
        isAllowedPaymentMethodSingle={props.isAllowedPaymentMethodSingle}
      >
        <FormattedMessage {...messages.bancontact} />
      </PaymentMethodForm.Header>

      <PaymentMethodForm.Body>
        <Adapter {...props} onError={handleError} />
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
